(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ritual-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('roseluno-hero-slider')) return;

  class RoselunoHeroSlider extends HTMLElement {
    connectedCallback() {
      this._frame = requestAnimationFrame(() => this._init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      clearTimeout(this._timer);
      this._events?.abort();
      this._observer?.disconnect();
      this._ready = false;
      this.removeAttribute('data-ready');
    }

    _init() {
      if (this._ready || !this.isConnected) return;
      this._slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      if (!this._slides.length) return;
      this._ready = true;
      this._events = new AbortController();
      this._dots = Array.from(this.querySelectorAll('[data-hero-to]'));
      this._toggle = this.querySelector('[data-hero-toggle]');
      this._status = this.querySelector('[data-hero-status]');
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._autoplay = this.dataset.autoplay === 'true' && this._slides.length > 1;
      const interval = Number(this.dataset.interval);
      this._interval = Number.isFinite(interval) ? Math.max(3000, Math.min(10000, interval)) : 5000;
      this._index = 0;
      this._paused = this._motion.matches;
      this._focusPaused = false;
      this._hover = false;
      this._touching = false;
      this._sectionSelected = false;
      this._blockSelected = false;
      this._inspecting = false;
      this._playIntent = null;
      const rect = this.getBoundingClientRect();
      this._visible = rect.bottom > 0 && rect.top < innerHeight;
      const on = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal: this._events.signal });

      // Separate selectors keep the theme's existing product carousels untouched.
      on(this, 'click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const toggle = target.closest('[data-hero-toggle]');
        if (toggle && this.contains(toggle)) {
          const action = this._playIntent || (this._wantsRotation() ? 'pause' : 'play');
          this._playIntent = null;
          this._paused = action === 'pause';
          this._focusPaused = false;
          this._schedule();
          return;
        }
        const dot = target.closest('[data-hero-to]');
        if (dot && this.contains(dot)) { this._go(Number(dot.dataset.heroTo), true); return; }
        const step = target.closest('[data-hero-step]');
        if (step && this.contains(step)) this._go(this._index + Number(step.dataset.heroStep), true);
      });
      on(this, 'pointerdown', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        // Record before focus changes the play/pause state: a click must never invert its intent.
        this._playIntent = target?.closest('[data-hero-toggle]') ? (this._wantsRotation() ? 'pause' : 'play') : null;
      });
      on(this, 'pointercancel', () => { this._playIntent = null; });
      on(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this._hover = true; this._schedule(); } });
      on(this, 'pointerleave', (event) => { if (event.pointerType === 'mouse') { this._hover = false; this._playIntent = null; this._schedule(); } });
      on(this, 'focusin', () => { this._focusPaused = true; this._schedule(); });
      on(this, 'keydown', (event) => {
        if (event.target instanceof Element && event.target.matches('input, textarea, select, [contenteditable]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this._focusPaused = true;
          this._go(this._index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(this, 'touchstart', (event) => {
        if (event.touches.length !== 1) { this._touchStart = null; return; }
        const point = event.touches[0];
        this._touchStart = { x: point.clientX, y: point.clientY, time: performance.now() };
        this._touching = true;
        this._schedule();
      }, { passive: true });
      on(this, 'touchend', (event) => {
        const start = this._touchStart;
        const point = event.changedTouches[0];
        this._touching = false;
        this._touchStart = null;
        if (start && point) {
          const dx = point.clientX - start.x, dy = point.clientY - start.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3 && performance.now() - start.time < 1500) {
            this._go(this._index + (dx < 0 ? 1 : -1), true);
            return;
          }
        }
        this._schedule();
      }, { passive: true });
      on(this, 'touchcancel', () => { this._touching = false; this._touchStart = null; this._schedule(); }, { passive: true });
      on(document, 'visibilitychange', () => this._schedule());
      on(this._motion, 'change', () => {
        if (this._motion.matches) this._paused = true;
        this._schedule();
      });

      // Selected Shopify blocks stay visible; removed sections release every timer/listener.
      const belongs = (event) => event.detail?.sectionId === this.dataset.sectionId || (event.target instanceof Node && (this.contains(event.target) || event.target.contains(this)));
      on(document, 'shopify:section:select', (event) => { if (belongs(event)) { this._sectionSelected = true; this._schedule(); } });
      on(document, 'shopify:section:deselect', (event) => { if (belongs(event)) { this._sectionSelected = false; this._schedule(); } });
      on(document, 'shopify:block:select', (event) => {
        if (!belongs(event)) return;
        this._blockSelected = true;
        const index = this._slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this._go(index, false);
        else this._schedule();
      });
      on(document, 'shopify:block:deselect', (event) => { if (belongs(event)) { this._blockSelected = false; this._schedule(); } });
      on(document, 'shopify:inspector:activate', () => { this._inspecting = true; this._schedule(); });
      on(document, 'shopify:inspector:deactivate', () => { this._inspecting = false; this._schedule(); });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          this._visible = entries[0].isIntersecting;
          this._schedule();
        }, { threshold: 0.01 });
        this._observer.observe(this);
      }
      this.setAttribute('data-ready', '');
      this._go(0, false);
    }

    _wantsRotation() {
      return this._autoplay && !this._paused && !this._focusPaused && !this._sectionSelected && !this._blockSelected && !this._inspecting;
    }

    _schedule() {
      clearTimeout(this._timer);
      const wanted = this._wantsRotation();
      const running = wanted && !this._hover && !this._touching && this._visible && !document.hidden;
      if (this._toggle) {
        const label = wanted ? this.dataset.pauseLabel : this.dataset.playLabel;
        this._toggle.setAttribute('aria-label', label);
        this._toggle.setAttribute('title', label);
        this._toggle.querySelector('[data-pause-icon]').hidden = !wanted;
        this._toggle.querySelector('[data-play-icon]').hidden = wanted;
      }
      this.dataset.playing = String(running);
      if (running) this._timer = setTimeout(() => this._go(this._index + 1, false), this._interval);
    }

    _go(index, announce) {
      if (!Number.isFinite(index) || !this._slides.length) return;
      this._index = ((index % this._slides.length) + this._slides.length) % this._slides.length;
      this._slides.forEach((slide, i) => {
        const active = i === this._index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        // tabindex fallback for browsers without inert support.
        slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          if (!('heroOriginalTabindex' in element.dataset)) element.dataset.heroOriginalTabindex = element.getAttribute('tabindex') ?? '';
          if (!active) element.setAttribute('tabindex', '-1');
          else if (element.dataset.heroOriginalTabindex === '') element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', element.dataset.heroOriginalTabindex);
        });
      });
      this._dots.forEach((dot, i) => {
        if (i === this._index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      // Warm up the next image without preloading every campaign at high priority.
      [this._index, (this._index + 1) % this._slides.length].forEach((i) => {
        this._slides[i].querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
      });
      if (announce && this._status) {
        const title = this._slides[this._index].dataset.slideTitle;
        this._status.textContent = `${this.dataset.slideLabel} ${this._index + 1} / ${this._slides.length}${title ? ': ' + title : ''}`;
      }
      this._schedule();
    }
  }
  customElements.define('roseluno-hero-slider', RoselunoHeroSlider);
})();

  } catch(e) { console.error(e); }
})();
})();
